import { writable } from 'svelte/store';

export const lobbyPlayerList = writable([]);
export const connected = writable(false);
export const isInRoom = writable(false);
export const isConnecting = writable(false);
export const isDisconnecting = writable(false);
export function syncConnectedWithPieState() {
    const _connected = window.isConnected()
    connected.set(_connected);
    if (!_connected) {
        isInRoom.set(false);
    }
    isConnecting.set(false);
    isDisconnecting.set(false);
}
globalThis.syncConnectedWithPieState = syncConnectedWithPieState;
globalThis.setMenuIsInRoom = inRoom => isInRoom.set(inRoom);
export function disconnect() {
    isDisconnecting.set(true);
    window.intentionalDisconnect = true;
    return window.pieDisconnect().then(syncConnectedWithPieState);
}